<template>
    <section class="profile-recommendations__message">
        <VJoyTextarea
            v-model="model"
            name="message-content"
            data-testid="reco-request-content"
            :placeholder="originalMessage"
            :invalid="field.$error"
            rows="10"
        ></VJoyTextarea>
        <br />
        <VJoyFormError v-if="field.$error" :errors="field.$errors" />
    </section>
</template>

<script setup lang="ts">
    import type {RegleFieldStatus} from '@regle/core';
    import {VJoyFormError, VJoyTextarea} from '@maltjoy/core-vue';

    const model = defineModel<string>({required: true});

    defineProps<{
        field: RegleFieldStatus<string>;
        originalMessage: string;
    }>();
</script>
